// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { formatNumber } from '@/utilities/number';
import { pluralize } from '@/utilities/pluralize';
import { Alert, Button } from '@mui/material';

interface SnapshotTruncationNoticeProps {
  shownCount: number;
  totalCount: number;
  isExporting: boolean;
  onExport: () => void;
}

/**
 * Tells the user a snapshot table lists only part of the snapshot and offers
 * the full Excel export. Renders nothing when every asset is listed.
 */
export function SnapshotTruncationNotice(props: SnapshotTruncationNoticeProps) {
  if (props.shownCount >= props.totalCount) {
    return null;
  }

  return (
    <Alert
      severity="info"
      action={
        <Button
          color="inherit"
          size="small"
          disabled={props.isExporting}
          onClick={props.onExport}
        >
          Export
        </Button>
      }
    >
      This table lists the first {formatNumber(props.shownCount)} of{' '}
      {pluralize(props.totalCount, { singular: 'asset' })} by serial number.
      Export the snapshot for the full list.
    </Alert>
  );
}
